export const EncounterReportEntity = {
  download(pdf: Blob, filename: string): void {
    const pdfBlob =
      pdf.type === "application/pdf"
        ? pdf
        : new Blob([pdf], { type: "application/pdf" });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    const link = document.createElement("a");

    link.href = pdfUrl;
    link.download = filename;
    document.body.appendChild(link);

    try {
      link.click();
    } finally {
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(pdfUrl), 60_000);
    }
  },
} as const;
